import React from 'react';

const Banner = () => (
  <section className="banner banner--smaller">
    <div className="banner__inner" style={{ backgroundImage: 'url(/image/banner.jpg)'/* , width:"100%" */ }}>
      <div className="container banner__detail">
        <div className="row">
          <div className="col">
            <h1 className="banner__title banner__title--boldest">
              Bize Ulaşın
            </h1>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <p className="banner__description">Her türlü soru, görüş ve önerileriniz için bize ulaşabilirsiniz.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Banner;
